<template>
  <div class="content">
    <v-row class="search" justify="center">
      <v-col cols="6">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          solo
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="listaDocentes"
      ref="lista_promedios"
      class="elevation-1"
      hide-default-footer
    >
      <template v-slot:item.indice="{ item }">{{item.idprofesor}}</template>
      <template v-slot:item.agregar="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="asignarProfesorMateria(item.idprofesor)">mdi-plus-circle</v-icon>
          </template>
          <span>Agregar Docente</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "indice"
        },
        {
          text: "Docente",
          align: "left",
          sortable: false,
          value: "nombre"
        },
        {
          text: "Dni",
          sortable: false,
          value: "dni"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "agregar",
          width: 50
        }
      ]
    };
  },
  mounted: function() {
    //console.log("Mounted listado Docente...!");
  },
  computed: {
    /*indice: function(item){
      let aux = indexOf();
      return 
    }*/
  },
  props: ["listaDocentes", "idmateria_agrupamiento"],
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    asignarProfesorMateria(idProfesor) {
      let params = "idprofesor=" + idProfesor;
      params += "&idmateria_agrupamiento=" + this.idmateria_agrupamiento;
      params += "&horas=NULL";

      let resultado = API.enviar("get", "asignarProfesorAMateria", params);

      resultado
        .then(result => {
          if (result.data.msj == "ok")
            this.$emit("listadoDocentes:obtenerListadoProfesores");
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}

.search {
  padding: 10px;
}
</style>